var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mx-3 my-n2 text-center py-2",attrs:{"rounded":"","elevation":"1","color":_vm.corStatus,"dark":"","height":"30","width":_vm.calcularLargura}},[_c('span',[_vm._v(_vm._s(_vm.$tc(`status_entidade.${_vm.status.toLowerCase()}`, 1)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }